var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ferramentas"}},[_c('barraLateral',{on:{"change-component":_vm.changeComponent}}),_c(_vm.activeComponent,{tag:"component",attrs:{"id":"comp"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }